import React from 'react';
import { MainContainerLayout } from 'clorian-frontend-components';
import ReportsContainer from '../containers/ReportsContainer';
import Header from '../components/structure/Header';
import Footer from '../components/structure/Footer';

const ReportsView = () => (
  <div>
    <Header />
    <MainContainerLayout>
      <ReportsContainer />
    </MainContainerLayout>
    <Footer />
  </div>
);

export default ReportsView;
